/**
 * @internal
 */
export async function handleSendRawTransactionRequest(options) {
    const { account, chainId, params: [rawTransaction], } = options;
    if (!account.sendRawTransaction) {
        throw new Error("The current account does not support sending raw transactions");
    }
    const txResult = await account.sendRawTransaction({
        rawTransaction,
        chainId,
    });
    return txResult.transactionHash;
}
//# sourceMappingURL=send-raw-transaction.js.map